import { Page } from '@/core/architecture'

import { GachaResultTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * GachaResult Page
 * Implemented as a practical sample.
 */
export const GachaResult: Page = () => {
  const { state, actions } = useViewModel()

  return <GachaResultTemplate state={state} {...actions} />
}
